import { StateParams } from '@uirouter/core';
import * as angular from 'angular';
import * as _ from 'underscore';
import { ViewportController } from '../../../../../app.common/modules/common/controllers/viewport-typed.controller';
import { EnumService } from '../../../../../app.common/modules/common/services/enum.service';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';
import { SalesAssistantRatingItem, SalesAssistantRatingPagingSettings, SalesAssistantSummaryResourceModel } from '../../../core/index';
import { IRetailerRootScope } from '../../../core/models';
import { JispPayService } from '../../../jispPay/jispPay.service';
import { StaffRatingService } from '../../staffRating.service';

interface ISortItem {
    title: string;
    class: string;
    order: number;
    column: string;
}

class StaffRatingDetailsComponent extends ViewportController {

    static $inject = ['$rootScope', '$scope', '$stateParams', '$q', '$timeout',
        'popupService', 'notificationService', 'enumService', 'staffRatingService', 'jispPayService', '$translate'];

    isArchive: boolean;
    staffID: number;
    total: number;
    data: Array<SalesAssistantRatingItem> = [];
    dataSummary: SalesAssistantSummaryResourceModel = {};
    waiting: boolean;
    isScrollLoad: boolean = true;

    dateOptions = {
        formatYear: 'yyyy',
        startingDay: 0,
        maxDate: new Date()
    };
    dateOptionsMax = {
        formatYear: 'yyyy',
        maxDate: new Date(),
        startingDay: 0,
        minDate: new Date(new Date().getTime() - (1000 * 60 * 60 * 24) * 30)
    };


    sortItems: ISortItem[] = [
        {
            title: this.$translate.instant('date'),
            class: 'amount-desc',
            order: 1,
            column: 'FeedbackLeftDateUTC'
        },
        {
            title: this.$translate.instant('date'),
            class: 'amount-asc',
            order: 0,
            column: 'FeedbackLeftDateUTC'
        },
        {
            title: this.$translate.instant('rating'),
            class: 'amount-desc',
            order: 1,
            column: 'Rating'
        },
        {
            title: this.$translate.instant('rating'),
            class: 'amount-asc',
            order: 0,
            column: 'Rating'
        }
    ];
    sort: ISortItem;

    settings = {
        pageSize: 10,
        currentPage: 1,
        dateFrom: new Date(new Date().getTime() - (1000 * 60 * 60 * 24) * 30),
        dateTo: new Date(),
        sortColumn: { name: 'Date', value: 'FeedbackLeftDateUTC' },
        sortVariants: [{ name: 'Date', value: 'FeedbackLeftDateUTC' }, { name: 'Rating', value: 'Rating' }],
        orderVariants: ['ascending', 'descending'],
        getFilter: (): SalesAssistantRatingPagingSettings => {
            let i = this.settings;
            return {
                Limit: i.pageSize,
                Offset: (i.currentPage - 1) * i.pageSize,
                SortColumn: this.sort.column,
                StartDate: this.settings.dateFrom ? this.settings.dateFrom : null,
                EndDate: this.settings.dateTo ? this.settings.dateTo : null,
                SortOrder: <SalesAssistantRatingPagingSettings.SortOrderEnum>this.sort.order
            };
        },
    };

    constructor(
        private $rootScope: IRetailerRootScope,
        private $scope: ng.IScope,
        private $stateParams: StateParams,
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private popupService: PopupService,
        private notificationService: NotificationService,
        private enums: EnumService,
        protected staffRatingService: StaffRatingService,
        private jispPayService: JispPayService,
        private $translate: angular.translate.ITranslateService
    ) {
        super($rootScope);
        this.staffID = this.$stateParams.id;
        this.isArchive = this.$stateParams.isArchive;
        this.init();
    }

    setSortOrder(sort: ISortItem) {
        if (sort === this.sort) {
            return;
        }
        this.sort = sort;
    }
    onDateChange() {
        this.dateOptions.maxDate = this.settings.dateTo;
        this.dateOptionsMax.minDate = this.settings.dateFrom;
    }

    private init = async () => {
        this.sort = this.sortItems[0];
        this.getData();
        this.getSummaryData();
    }

    private loadMore = async () => {
        if (this.waiting) {
            return;
        }
        this.isScrollLoad = true;
        await this.getData();

    }

    private getAvatarUrl(id: number): string {
        return (id)
            ? this.jispPayService.getAvatarUrl(id, 120, 120)
            : '';
    }

    private getShopperAvatarUrl(id: number): string {
        return (id)
            ? this.staffRatingService.getShopperAvatarUrl(id, 48, 48)
            : '';
    }

    private async showComments() {
        this.data = [];
        this.settings.currentPage = 1;
        if (this.waiting) {
            return;
        }
        this.isScrollLoad = false;
        this.getData();

    }

    private async getData() {
        this.waiting = true;
        var filter = this.settings.getFilter();
        var data = await this.staffRatingService.getStaffRatingDataByID(this.staffID, filter);

        _.forEach(<SalesAssistantRatingItem[]>data.Items, (shopperComment) => {
            shopperComment.AvatarUrl = this.getShopperAvatarUrl(shopperComment.AvatarID);
        });

        if (this.isScrollLoad) {
            this.data = this.data.concat(data.Items);
        } else {
            this.data = data.Items;
        }
        this.settings.currentPage++;
        this.total = data.Total;
        this.waiting = false;
    }

    private async getSummaryData() {
        var data = await this.staffRatingService.getStaffRatingSummaryByID(this.staffID);
        data.AvatarUrl = this.getAvatarUrl(data.AvatarID);
        this.dataSummary = data;
        console.log(data);
    }
}

angular
    .module('naut').component('staffRatingDetails', {
        template: require('./staffRatingDetails.component.html'),
        controller: StaffRatingDetailsComponent,
        controllerAs: 'vm'
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/staffRating/components/details/staffRatingDetails.component.ts